import * as React from 'react';

import { cn } from '@/lib/utils';
import { FieldErrorIcon, invalidFieldClassName } from './field-error';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    const invalid = props['aria-invalid'] === true || props['aria-invalid'] === 'true';
    return (
      <div className="relative w-full">
        <textarea
          className={cn(
            'flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
            className,
            invalid && cn(invalidFieldClassName, 'pr-9'),
          )}
          ref={ref}
          {...props}
        />
        {invalid && <FieldErrorIcon className="absolute right-3 top-3" />}
      </div>
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
